import React, { useState } from "react";
import {
  Modal,
  Button,
  Form,
  Alert,
  Container,
  FloatingLabel,
} from "react-bootstrap";
import { FaEnvelope } from "react-icons/fa";
import axios from "axios";
import { API_URL } from "../Config";

const ContactModal = ({ show, handleClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile_number: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // Form input change handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Form validation function
  const validateForm = () => {
    const newErrors = {};

    if (!formData.name) newErrors.name = "Name is required.";
    if (!formData.email) {
      newErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid email format.";
    }

    if (!formData.mobile_number) {
      newErrors.mobile_number = "Mobile number is required.";
    } else if (!/^\d{10}$/.test(formData.mobile_number)) {
      newErrors.mobile_number = "Mobile number must be 10 digits.";
    }

    if (!formData.message) newErrors.message = "Message is required.";

    return newErrors;
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    setErrors(validationErrors);
    setErrorMessage("");

    if (Object.keys(validationErrors).length === 0) {
      // Form is valid, proceed with submission
      console.log("Form submitted successfully!", formData);

      try {
        var url = API_URL + "inquiry/contactUs";
        const response = await axios.post(url, formData);
        setSuccessMessage(response.data.message);
        setFormData({
          name: "",
          email: "",
          mobile_number: "",
          message: "",
        });
      } catch (error) {
        // Handle any errors
        if (error.response) {
          // The server responded with an error
          console.error("Error response:", error.response.data);
          setErrors("An error occurred. Please try again.");
        } else if (error.request) {
          // The request was made but no response was received
          console.error("Error request:", error.request);
          setErrors("No response from the server. Please try again later.");
        } else {
          // Something else caused the error
          console.error("Error:", error.message);
          setErrors("An unknown error occurred. Please try again.");
        }
      } finally {
        setIsSubmitting(false);
      }

      handleClose(); // Close modal
    }
  };

  return (
    <Container>
      <Modal size="lg" show={show} onHide={handleClose} centered>
        <Modal.Header closeButton className="custom-modal-header">
          <Modal.Title>
            <FaEnvelope className="me-2" />
            Contact Us
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="custom-modal-body">
          {successMessage && <Alert variant="success">{successMessage}</Alert>}
          {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
          <Form>
            <p>
              For all queries, Please enter your details and we can help you.
            </p>
            <br />
            <Form.Group className="mb-3" controlId="name">
              <FloatingLabel
                controlId="floatingInput"
                label="Name"
                className="mb-3"
              >
                <Form.Control
                  type="text"
                  placeholder="Enter your name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  isInvalid={!!errors.name}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.name}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Form.Group>
            <Form.Group className="mb-3" controlId="email">
              <FloatingLabel
                controlId="floatingInput"
                label="Email address"
                className="mb-3"
              >
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  isInvalid={!!errors.email}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Form.Group>
            <Form.Group className="mb-3" controlId="mobile_number">
              <FloatingLabel
                controlId="floatingInput"
                label="Mobile Number"
                className="mb-3"
              >
                <Form.Control
                  type="mobile"
                  placeholder="Mobile Number"
                  name="mobile_number"
                  value={formData.mobile_number}
                  onChange={handleChange}
                  isInvalid={!!errors.mobile_number}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.mobile_number}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Form.Group>
            <Form.Group className="mb-3" controlId="message">
              <FloatingLabel controlId="floatingInput" label="Message">
                <Form.Control
                  as="textarea"
                  rows={5}
                  style={{ height: "100px" }}
                  placeholder="Your message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  isInvalid={!!errors.message}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.message}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="custom-modal-footer">
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="primary"
            type="submit"
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default ContactModal;
